import React from "react";
import './GridLoader.css';

const GridLoader = props => {
  const { loading, columnCount } = props;

  return (
    <>
      {loading ? (
        <>
          {Array.from(Array(columnCount), (e, i) => (
            <div key={i} className="card"> {/* Added unique key */}
              <div className="card__image loading"></div>
              <div className="card__title loading"></div>
              <div className="card__description loading"></div>
            </div>
          ))}
        </>
      ) : null}
    </>
  );
}

export default GridLoader;